import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-telefon-entfernen-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerTelefonEntfernenAdminEffects {

    BenutzerTelefonEntfernenAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_TELEFON_ENTFERNEN_ADMIN),
        mergeMap((x: ac.PostBenutzerTelefonEntfernenAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerTelefonEntfernenAdmin(x.benutzerTelefonEntfernenRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerTelefonEntfernenAdminErfolgreichAction(result, x.benutzerTelefonEntfernenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerTelefonEntfernenAdminFehlerAction(error, x.benutzerTelefonEntfernenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
